import { render, staticRenderFns } from "./FreelanceInvoiceContainer.vue?vue&type=template&id=436cb00c&scoped=true&"
import script from "./FreelanceInvoiceContainer.vue?vue&type=script&lang=js&"
export * from "./FreelanceInvoiceContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436cb00c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
